import { common } from '@ocean/ui'
import { Info } from './ListItemInfo.styled'

const { Typography } = common

export type ListItemInfoProps = {
  info?: string
  dataTest?: string
}

const ListItemInfo: React.FC<ListItemInfoProps> = ({ info, dataTest }) => {
  if (!info) return null
  return (
    <Typography variant='small'>
      <Info data-test={dataTest}>{info}</Info>
    </Typography>
  )
}

export default ListItemInfo
